import type { ProjectStatus } from '@/enteties/project/modal';
import * as m from '@paraglide/messages';

type StatusMessages = {
  [key in ProjectStatus]: {
    message: string;
    color: string;
    hint?: string;
  };
};

const statusColors = {
  off: {
    filled: '',
    border: 'text-status-off border-status-off bg-accent',
  },
  info: {
    filled: 'text-status-info border-none bg-status-info-bg',
    border: 'text-status-info border-status-info bg-accent',
  },
  success: {
    filled: 'text-status-success border-none bg-status-success-bg',
    border: '',
  },
  warning: {
    filled: 'text-status-warning border-none bg-status-warning-bg',
    border: 'text-status-warning border-status-warning-bg bg-accent',
  },
  error: {
    filled: 'text-status-error border-none bg-status-error-bg',
    border: '',
  },
  tertiary: {
    filled: 'border-none bg-status-tertiary',
    border: 'text-status-tertiary border-status-tertiary',
  },
};

export const projectStatus: StatusMessages = {
  '': {
    message: m.project_status_null(),
    color: statusColors.off.border,
    hint: m.project_status_null_hint(),
  },
  CREATING: {
    message: m.project_status_CREATING(),
    color: statusColors.info.border,
    hint: m.project_status_CREATING_hint(),
  },
  EMPTY: {
    message: m.project_status_EMPTY(),
    color: statusColors.off.border,
    hint: m.project_status_EMPTY_hint(),
  },
  BUILD_STARTED: {
    message: m.project_status_BUILD_STARTED(),
    color: statusColors.info.filled,
    hint: m.project_status_BUILD_STARTED_hint(),
  },
  BUILD_STOPPED: {
    message: m.project_status_BUILD_STOPPED(),
    color: statusColors.warning.filled,
  },
  BUILD_FAILED: {
    message: m.project_status_BUILD_FAILED(),
    color: statusColors.error.filled,
    hint: m.project_status_BUILD_FAILED_hint(),
  },
  DEPLOYING: {
    message: m.project_status_DEPLOYING(),
    color: statusColors.tertiary.filled,
    hint: m.project_status_DEPLOYING_hint(),
  },
  DEPLOY_FAILED: {
    message: m.project_status_DEPLOY_FAILED(),
    color: statusColors.error.filled,
    hint: m.project_status_DEPLOY_FAILED_hint(),
  },
  STARTING: {
    message: m.project_status_STARTING(),
    color: statusColors.info.filled,
    hint: m.project_status_STARTING_hint(),
  },
  RUN_ERROR: {
    message: m.project_status_RUN_ERROR(),
    color: statusColors.error.filled,
    hint: m.project_status_RUN_ERROR_hint(),
  },
  RUN_PROBLEM: {
    message: m.project_status_RUN_PROBLEM(),
    color: statusColors.error.filled,
    hint: m.project_status_RUN_PROBLEM_hint(),
  },
  RUNNING: {
    message: m.project_status_RUNNING(),
    color: statusColors.success.filled,
    hint: m.project_status_RUNNING_hint(),
  },
  STOPPED: {
    message: m.project_status_STOPPED(),
    color: statusColors.warning.filled,
    hint: m.project_status_STOPPED_hint(),
  },
  STOPPING: {
    message: m.project_status_STOPPING(),
    color: statusColors.tertiary.border,
  },
  FROZEN: {
    message: m.project_status_FROZEN(),
    color: statusColors.warning.border,
    hint: m.project_status_FROZEN_hint(),
  },
  STOPPED_WITH_ERROR: {
    message: m.project_status_STOPPED_WITH_ERROR(),
    color: statusColors.error.filled,
    hint: m.project_status_STOPPED_WITH_ERROR_hint(),
  },
  SCALING: {
    message: m.project_status_SCALING(),
    color: statusColors.tertiary.filled,
    hint: m.project_status_SCALING_hint(),
  },
  'Cluster in healthy state': {
    message: m.project_status_clusterHealthyState(),
    color: statusColors.success.filled,
  },
  'Setting up primary': {
    message: m.project_status_settingUpPrimary(),
    color: statusColors.info.filled,
  },
  'Waiting for the instances to become active': {
    message: m.project_status_waitingForInstances(),
    color: statusColors.info.filled,
  },
  'Creating a new replica': {
    message: m.project_status_creatingNewReplica(),
    color: statusColors.tertiary.filled,
  },
};
